// extracted by mini-css-extract-plugin
module.exports = {"title":"entity_list_link_title-module__title--h9JzK"};